import { render, staticRenderFns } from "./ProgressLoader.vue?vue&type=template&id=3c106e5e&scoped=true&"
import script from "./ProgressLoader.vue?vue&type=script&lang=js&"
export * from "./ProgressLoader.vue?vue&type=script&lang=js&"
import style0 from "./ProgressLoader.vue?vue&type=style&index=0&id=3c106e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c106e5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c106e5e')) {
      api.createRecord('3c106e5e', component.options)
    } else {
      api.reload('3c106e5e', component.options)
    }
    module.hot.accept("./ProgressLoader.vue?vue&type=template&id=3c106e5e&scoped=true&", function () {
      api.rerender('3c106e5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/components/ProgressLoader.vue"
export default component.exports